import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import Collapse from 'components_new/atoms/Collapse'

import MetricsFilter from '../MetricsFilter'
import CategoryTabs from '../CategoryTabs'
import StandardSearch from '../StandardSearch'

interface Props {
  debounceSearch?: boolean
  sx?: SxProps
  search: string | null
  setSearch: (search: string | null) => void
  category: string | null
  setCategory: (category: string | null) => void
  subcategory: string | null
  setSubcategory: (subcategory: string | null) => void
}

const MetricsTableHero = React.memo((props: Props) => {
  const {
    debounceSearch,
    sx,
    search,
    category,
    setSearch,
    setCategory,
    subcategory,
    setSubcategory
  } = props

  const hasSelectedCategory = Boolean(category)

  // success
  return (
    <Box sx={{ ...sx }}>
      <>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            gap: 1,
            justifyContent: 'space-between',
            mb: 1
          }}
        >
          <CategoryTabs
            type="metric"
            category={category}
            setCategory={setCategory}
          />

          <StandardSearch
            debounce={debounceSearch}
            search={search}
            setSearch={setSearch}
          />
        </Box>

        <Collapse in={Boolean(hasSelectedCategory)}>
          <MetricsFilter
            sx={{ mb: 2 }}
            category={category}
            setSubcategory={setSubcategory}
            subcategory={subcategory}
          />
        </Collapse>
      </>
    </Box>
  )
})

export default MetricsTableHero
